module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-500.87284894.woff";